import { Link } from "react-router-dom";

const socials = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-youtube-line", label: "视频号" },
  { icon: "ri-mail-line", label: "邮箱" },
];

const friendLinks = [
  { label: "电影资料库", to: "/category/movie" },
  { label: "电视剧频道", to: "/category/tv" },
  { label: "影评专题", to: "/category/review" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-primary-100">
      <div className="mx-auto w-full max-w-site px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg text-background-50">
                <i className="ri-movie-2-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">亚洲天堂</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
              亚洲天堂是面向华语影视爱好者的资讯与影评分享平台，汇聚电影、电视剧动态与深度影评，
              帮助影迷高效发现值得一看的好作品。
            </p>
            <div className="mt-5 flex gap-2">
              {socials.map((item) => (
                <span
                  key={item.label}
                  title={item.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-primary-800 text-base text-primary-100 transition-colors hover:bg-accent-500 hover:text-background-50"
                >
                  <i className={item.icon} aria-hidden="true"></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-background-50">内容导航</h4>
            <ul className="flex flex-col gap-2.5 text-sm">
              <li><Link to="/category/movie" className="cursor-pointer text-primary-200 transition-colors hover:text-accent-400">电影资讯</Link></li>
              <li><Link to="/category/tv" className="cursor-pointer text-primary-200 transition-colors hover:text-accent-400">电视剧动态</Link></li>
              <li><Link to="/category/review" className="cursor-pointer text-primary-200 transition-colors hover:text-accent-400">影评专题</Link></li>
              <li><Link to="/search?q=推荐" className="cursor-pointer text-primary-200 transition-colors hover:text-accent-400">站内搜索</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-background-50">友情链接</h4>
            <ul className="flex flex-col gap-2.5 text-sm">
              {friendLinks.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="cursor-pointer text-primary-200 transition-colors hover:text-accent-400">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-primary-800 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center">
          <p>© 2025 亚洲天堂 · 影视资讯与影评分享平台 · 本站内容为演示示例</p>
          <p>本站不提供视频播放与下载，全部内容仅供影迷交流参考</p>
        </div>
      </div>
    </footer>
  );
}